<template>
	<div class="app-container userDetail">
		<el-card class="tabBox">
			<el-tabs v-model="activeName">
				<el-tab-pane label="用户详情" name="info">
					<infoTab :id="id" :name="activeName" @func="setTab"></infoTab>
				</el-tab-pane>
				<el-tab-pane label="举办赛事" name="hold">
					<holdTab :id="id" :name="activeName"></holdTab>
				</el-tab-pane>
				<el-tab-pane label="参与赛事" name="join">
					<joinTab :id="id" :name="activeName"></joinTab>
				</el-tab-pane>
				<el-tab-pane label="登录日志" name="log">
					<logTab :id="id" :name="activeName"></logTab>
				</el-tab-pane>
			</el-tabs>
		</el-card>
	</div>
</template>

<script>
	import * as API_User from "@/api/sportManage/user";
	import infoTab from './competition/info.vue'
	import holdTab from './competition/hold.vue'
	import joinTab from './competition/join.vue'
	import logTab from './competition/log.vue'

	
	export default {
		name: "usersDetail",
		components: {
			infoTab,holdTab,joinTab,logTab
		},
		data() {
			return {
				pageName: '用户详情',
				activeName: '',
				userDetail: {},
			};
		},
		created() {
			let { query } = this.$route
			this.id = query.id;
			this.$nextTick(() => {
				this.activeName = 'info'
			})
		},
		methods: {
			setTab(e) {
				console.log(e);
				this.activeName = e
			},
		},
	};
</script>

<style scoped lang="scss">
	@import "../../../assets/styles/common.scss";

	.userDetail {
		.maininfo {
			display: flex;

			.img {
				width: 120px;
				height: 120px;
				border-radius: 50%;
			}

			.userName {
				margin-top: 10px;
				font-size: 16px;
				color: #666666;
				text-align: center;
				font-weight: bold;
			}

			.other {
				flex: 1;
				min-width: 0;

				.label {
					color: #999;
				}

				.value {
					line-height: 40px;
				}
			}
		}

		.datas {
			.data {
				display: flex;
				align-items: center;
				flex-direction: column;
				justify-content: center;
				flex: 1;
				min-width: 0;
				height: 100px;
				border-right: 1px solid #eee;
				color: #333;

				&:last-child {
					border: none;
				}
			}

			.label {
				color: #999;
			}

			.numb {
				font-size: 30px;
				line-height: 44px;
				font-weight: bold;
				margin-right: 20px;
			}
		}

		.tabBox {}

		//导视
		.guide {
			font-weight: bold;
			font-size: 14px;
			color: #666666;
			margin: 10px 0 10px 0;

			.icon {
				font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;
				font-weight: 700;
				color: #409EFF;
				margin-right: 5px;
			}
		}

		// 查看跳转
		.examine {
			cursor: pointer;
			margin-left: 5px;
			color: rgb(64, 158, 255);
		}

	}
</style>
<style lang="scss">
	.userDetail {

		.datas,
		.maininfo {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 100%;
			// height: 150px;
		}

		.datas {
			.el-card__body {
				height: 160px;
			}
		}
	}
</style>